import * as _ from "lodash";
import React from "react";
import PhysicalLocation from "domain/physicalLocation";
import Commodity from "domain/commodity";
import PageFilter from "./pageFilter";
import Chip from "common/ui/Chip";
import { Trader } from "features/settings/traders/trader";
import './PageFilterChips.scss';

export type PageFilterChipsProps = {
    filter: PageFilter;
    locations: PhysicalLocation[];
    showTraders?: boolean;
    applyFilter(filterParams: PageFilter): void;
};

const PageFilterChips: React.FC<PageFilterChipsProps> = props => {

    function isLoaded(): boolean {
        return props.filter != null;
    }

    function getLocationList(): PhysicalLocation[] {

        const homeLocations = _.orderBy(
            props.locations.filter(m => m.homeLocation == null),
            l => l.name);

        const allLocations = homeLocations.flatMap(hl => [
            hl,
            ..._.orderBy(props.locations.filter(l => l.homeLocation?.id === hl.id),
                l => l.name)
        ]);

        return allLocations.filter(l => props.filter.locations.some(l2 => l2.id === l.id));
    }

    function removeLocation(location: PhysicalLocation) {
        const newFilter = {...props.filter};
        newFilter.locations = newFilter.locations.filter(l => l.id !== location.id);
        
        props.applyFilter(newFilter);
    }

    function getCommodityList(): Commodity[] {
        return _.orderBy(props.filter.commodities, m => m.name);
    }

    function removeCommodity(commodity: Commodity) {
        const newFilter = {...props.filter};
        newFilter.commodities = newFilter.commodities.filter(c => c.id !== commodity.id);
        
        props.applyFilter(newFilter);
    }

    function removeTrader(trader: Trader) {
        const newFilter = {...props.filter};
        newFilter.traders = newFilter.traders.filter(t => t.userId !== trader.userId);
        
        props.applyFilter(newFilter);
    }

    function removeWillSell() {
        props.applyFilter({...props.filter, willSell: null});
    }


    if (!isLoaded()) return <></>;


    return <div className="page-filter-chips">
        {getLocationList().map(l => 
            <Chip key={l.id} onDelete={() => removeLocation(l)}>
                {l.name}
            </Chip>
        )}

        {getCommodityList().map(c => 
            <Chip key={c.id} onDelete={() => removeCommodity(c)}>
                {c.name}
            </Chip>
        )}

        {props.filter.willSell != null &&
            <Chip onDelete={() => removeWillSell()}>
                {props.filter.willSell ? "Will Sell" : "Will Buy"}
            </Chip>
        }

        {props.showTraders &&
            props.filter.traders.map(t => 
                <Chip key={t.userId} onDelete={() => removeTrader(t)}>
                    {t.lastName}
                </Chip>
            )
        }
    </div>
}

export default React.memo(PageFilterChips);